import React, { Component } from 'react';
import CarouselSettingComponent from '../components/carouselSettingComponent';
import {getAllCarouselSettings, addCarouselData,
            deleteCarouselData, editCarouselData,updateCarouselSequence} from '../action/carouselSettingAction';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

export class CarouselSettingContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        this.props.actions.getAllCarouselSettings();
    }
    getCarouselSetting = () =>{
        this.props.actions.getAllCarouselSettings(
            this.props.dispatch
        )
    }
    updateCarouselSetting = (formData) =>{
        this.props.actions.editCarouselData(
            formData,
            this.props.dispatch
        )
    }
    saveSequenceList = (array) =>{
        this.props.actions.updateCarouselSequence(
            array,
            this.props.dispatch
        )
    }
    addCarouselSetting = (formData) =>{
        this.props.actions.addCarouselData(
            formData,
            this.props.dispatch
        )
    }
    deleteCarousel = (itemId) => {
        this.props.actions.deleteCarouselData(
            itemId,
            this.props.dispatch
        )
    }
    render(){
        return(
            <div>
                <CarouselSettingComponent
                    CarouselSettingDetails = {this.props.CarouselSettingData}
                    addCarousel = {this.addCarouselSetting}
                    deleteCarouselItem = {this.deleteCarousel}
                    getCarouselSetting ={this.getCarouselSetting}
                    updateCarousel = {this.updateCarouselSetting}
                    saveSequenceList = {this.saveSequenceList}
                >
                </CarouselSettingComponent>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getAllCarouselSettings,
            addCarouselData,
            deleteCarouselData,
            editCarouselData,
            updateCarouselSequence
        },
            dispatch)
    };
}
function mapStateToProps({ CarouselSettingReducer }) {
    console.log(CarouselSettingReducer);
    return {
        CarouselSettingData : {
            errorCode : CarouselSettingReducer.errorCode,
            statusCode : CarouselSettingReducer.statusCode,
            carouselList : CarouselSettingReducer.carouselList,
            message : CarouselSettingReducer.message,
            UpdatedList : CarouselSettingReducer.UpdatedList
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CarouselSettingContainer));